export default "__VITE_ASSET__f11027ab__"